export function audioPlayer() {
    return {
        isPlaying: false,
        duration: 0,
        currentTime: 0,
        audio: null,

        init() {
            this.audio = this.$refs.audio;

            this.audio.addEventListener('loadedmetadata', () => {
                this.duration = this.audio.duration;
            });

            this.audio.addEventListener('timeupdate', () => {
                this.currentTime = this.audio.currentTime;
            });

            this.audio.addEventListener('ended', () => {
                this.isPlaying = false;
                this.currentTime = 0;
            });

            // If metadata already loaded (cached)
            if (this.audio.readyState >= 1) {
                this.duration = this.audio.duration;
            }
        },

        toggle() {
            if (this.isPlaying) {
                this.audio.pause();
            } else {
                this.audio.play();
            }
            this.isPlaying = !this.isPlaying;
        },

        get remainingTime() {
            const remaining = this.duration - this.currentTime;
            return this.formatTime(remaining);
        },

        get totalTime() {
            return this.formatTime(this.duration);
        },

        formatTime(seconds) {
            if (!seconds || isNaN(seconds)) return '0:00';
            const mins = Math.floor(seconds / 60);
            const secs = Math.floor(seconds % 60);
            return `${mins}:${secs.toString().padStart(2, '0')}`;
        }
    };
}

export function registerAudioPlayer(Alpine) {
    Alpine.data('audioPlayer', audioPlayer);
}
